import defaultRecipeImage from '@/assets/images/recipe-details-default.png';

export const DEFAULT_RECIPE_IMAGE = defaultRecipeImage;

